import Stack from "@mui/material/Stack";
import React from "react";
import ContentSection from "shared/components/Drawer/components/ContentSection";
import TextField from "shared/components/Form/TextField";
import { COLOR_BLACK } from "shared/theme/colors";
import { useMetadata } from "../../../../stores/useMetadata";

const GeneralMetadata = () => {
  const {
    gameDescription,
    setGameDescription,
    gameOptimisedDescription,
    setGameOptimisedDescription,
    gameShortDescription,
    setGameShortDescription,
  } = useMetadata();

  return (
    <ContentSection title="GENERAL">
      <Stack spacing="1rem">
        <TextField
          id="metadataGameDescription"
          label="Original Game Description"
          secondaryLabel="Game description that we get from game provider"
          placeholder="Enter a game description"
          fullWidth
          rows={7}
          multiline
          value={gameDescription}
          onChange={(e) => setGameDescription(e.target.value)}
          labelColor={COLOR_BLACK}
          secondaryLabelColor={COLOR_BLACK}
        />

        <TextField
          id="metadataGameOptimisedDescription"
          label="Optimised Description"
          secondaryLabel="Game description optimised by OpenAI"
          placeholder="Enter a optimised description"
          fullWidth
          rows={7}
          multiline
          value={gameOptimisedDescription}
          onChange={(e) => setGameOptimisedDescription(e.target.value)}
          labelColor={COLOR_BLACK}
          secondaryLabelColor={COLOR_BLACK}
        />

        <TextField
          id="metadataGameShortDescription"
          label="Short Description"
          secondaryLabel="Game description that appears on the hover over state"
          placeholder="Enter a short game description"
          fullWidth
          rows={7}
          multiline
          value={gameShortDescription}
          onChange={(e) => setGameShortDescription(e.target.value)}
          labelColor={COLOR_BLACK}
          secondaryLabelColor={COLOR_BLACK}
        />
      </Stack>
    </ContentSection>
  );
};

export default GeneralMetadata;
